import React, { useEffect } from "react";
import { renderMathml } from "@pearsontechnology/bronte-lib-math/readonly";
import type { JournalSchema } from "../types";

type JournalPluginActivityChromeProps = {
  schema: NonNullable<JournalSchema>;
  componentId: string;
  journalPluginTargetItemElId: string;
  children?: React.ReactNode;
};

export const JournalPluginActivityChrome: React.FC<JournalPluginActivityChromeProps> = ({
  schema: { activityLabel, activityTitle, instructions, captions, credit },
  componentId,
  journalPluginTargetItemElId,
  children,
}) => {
  useEffect(() => {
    const el = document.getElementById(journalPluginTargetItemElId);
    if (el) {
      try {
        renderMathml(el);
      } catch {
      }
    }
  }, [activityLabel, activityTitle, instructions, captions, credit, journalPluginTargetItemElId]);

  return (
    <div style={{ height: "100%" }}>
      <h4 className="component-label-section">
        {activityLabel && (
          <span
            className="component-label"
            data-id={`${componentId}-activityLabel`}
            dangerouslySetInnerHTML={{ __html: activityLabel }}
          />
        )}
        {activityTitle && (
          <span
            className="component-title"
            data-id={`${componentId}-activityTitle`}
            dangerouslySetInnerHTML={{ __html: activityTitle }}
          />
        )}
      </h4>
      {instructions && (
        <div
          className="component-instructions"
          data-id={`${componentId}-instructions`}
          dangerouslySetInnerHTML={{ __html: instructions }}
        />
      )}
      {children}
      {captions && (
        <figcaption>
          <div
            className="component-caption"
            data-id={`${componentId}-captions`}
            dangerouslySetInnerHTML={{ __html: captions }}
          />
        </figcaption>
      )}
      {credit && (
        <div
          className="component-credit"
          data-id={`${componentId}-credit`}
          dangerouslySetInnerHTML={{ __html: credit }}
        />
      )}
    </div>
  );
};
